<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.company.companyList')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('filters')}}</div>
                        <div class="text-right">
                            <b-button variant="primary" size="sm" @click="detailedSearch = !detailedSearch">
                                {{$t('button.detailedSearch')}}</b-button>
                            <b-button variant="default" size="sm" @click="clearSearch()">{{$t('button.resetFilter')}}
                            </b-button>
                        </div>
                    </div>

                    <div class="card-body">
                        <form role="form">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>{{$t('form.company.searchCriteria')}}</label>
                                        <v-select @input="loadPreset" label="name" :options="presetList"
                                            v-model="preset">
                                        </v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.companyName')}}</label>
                                        <input type="text" class="search form-control" v-model="search.name"
                                            @keyup="searchCompany">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.department')}}</label>
                                        <input type="text" v-model="search.department" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.country')}}</label>
                                        <v-select @input="searchCompany" label="printable_name" :options="countries"
                                            v-model="search.country"
                                            :reduce="countries => countries.printable_name">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.title')}}</label>
                                        <v-select @input="searchCompany" :options="titles" v-model="search.Title"
                                            :reduce="titles => titles"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="detailedSearch">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.firstName')}}</label>
                                        <input type="text" v-model="search.firstName" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.lastName')}}</label>
                                        <input type="text" v-model="search.lastName" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.streetAddress')}}</label>
                                        <input type="text" v-model="search.streetAddress" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.city')}}</label>
                                        <input type="text" v-model="search.city" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.postalCode')}}</label>
                                        <input type="text" v-model="search.zip" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.phone')}}</label>
                                        <input type="text" v-model="search.phone" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.mobile')}}</label>
                                        <input type="text" v-model="search.mobile" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.email')}}</label>
                                        <input type="text" v-model="search.email" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <label>{{$t('form.company.webAddress')}}</label>
                                        <input type="text" v-model="search.webAddress" @keyup="searchCompany"
                                            class="search form-control">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>{{$t('form.company.notes')}}</label>
                                        <textarea v-model="search.notes" @keyup="searchCompany" rows="5"
                                            class="form-control"></textarea>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <hr>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <input type="text" v-model="preset.name" class="form-control"
                                            :placeholder="$t('form.company.presetName')">
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <button type="button" class="btn btn-primary"
                                        @click="savePreset">{{$t('button.save')}}</button>
                                    <button type="button" class="btn btn-danger" v-show="presetSelected"
                                        @click="deletePreset">{{$t('button.delete')}}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- List -->
                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.company.companyList')}}</div>
                    </div>

                    <div class="card-body table-responsive p-0">
                        <table class="table" v-if="companies.length">
                            <thead>
                                <tr class="header">

                                    <th>{{$t('form.company.companyName')}}</th>
                                    <th>{{$t('form.company.department')}}</th>
                                    <th>{{$t('form.company.country')}}</th>
                                    <th class="text-right fix-action">{{$t('form.company.action')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(company, index) in companies" v-bind:key="index"
                                    v-on:dblclick="editCompany(company.ID)">
                                    <td>
                                        {{company.CompanyName}}
                                    </td>
                                    <td>
                                        {{company.Department}}
                                    </td>
                                    <td>
                                        {{company.Country}}
                                    </td>
                                    <td class="text-right"><button v-if="permissions.viewCompanies"
                                            class="btn btn-info btn btn-sm" v-on:click="editCompany(company.ID)"><span
                                                class="fa fa-edit"></span></button>
                                        <button v-if="permissions.deleteCompanies" class="btn btn-danger btn btn-sm"
                                            v-on:click="deleteCompany(company.ID, index)"><span
                                                class="fa fa-trash"></span></button>
                                    </td>

                                </tr>

                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>

                    <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                        @paginate="paginate()">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions'],

        data() {
            return {
                isLoading: false,
                fullPage: true,

                alert: false,
                alertClass: '',
                alertMessage: '',

                detailedSearch: false,
                presetSelected: false,
                request_source: '',

                pagination: {
                    current_page: 1
                },

                search: {},

                preset: {
                    name: '',
                    entity: 'company',
                    value: {}
                },

                titles: ["Mr.", "Mrs.", "Sir", "Madam", "Ms", "Miss", "Dr."],
                
                presetList: [],
                companies: [],
                countries: [],
            }
        },

        async mounted() {
            this.isLoading = true;

            if (!this.permissions.viewCompanies) {
                this.$router.push('/');
                return;
            }

            await this.getCountries();

            if (localStorage.getItem('filter-company')) {
                this.search = JSON.parse(localStorage.getItem('filter-company'));
            }

            this.getCompanies();
            this.getPresets();
        },

        watch: {
            search: {
                handler() {
                    localStorage.setItem('filter-company', JSON.stringify(this.search));
                },
                deep: true
            }
        },

        methods: {

            getCountries() {
                axios
                    .get("/api/countries")
                    .then(({data}) => this.countries = data);
            },

            getCompanies() {
                let source = axios.CancelToken.source();

                if (this.request_source != '')
                    this.request_source.cancel('Operation canceled by the user.');

                this.request_source = source;

                this.isLoading = true;

                axios
                    .get('/api/companies?page=' + this.pagination.current_page, {
                        params: this.search,
                        cancelToken: this.request_source.token
                    })
                    .then(response => {
                        this.companies = response.data.data.data;
                        this.pagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {

                        console.log(error.response);
                    });
            },

            editCompany(id) {
                if (!this.permissions.viewCompanies) return;

                this.$router.push({
                    name: 'CompanyEdit',
                    params: {
                        id: id
                    }
                });
            },

            deleteCompany(id, index) {
                if (!this.permissions.deleteCompanies) return;

                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    this.isLoading = true;
                    axios.delete('/api/companies/' + id)
                        .then(response => {
                            this.isLoading = false;

                            if (response.data.warning)
                                this.showAlert(response.data.message, 'danger');
                            else {
                                this.companies.splice(index, 1);
                                this.getCompanies();
                                this.showAlert(response.data.message);
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });


                }
            },

            searchCompany() {
                this.pagination.current_page = 1;
                this.getCompanies();
            },

            // Clear search input fields
            clearSearch() {
                this.search = {
                    title: '',
                    country: '',
                };

                this.searchCompany();
            },

            paginate() {
                this.getCompanies();
            },

            // Save a Preset with Unique Name
            savePreset() {
                this.isLoading = true;
                this.alert = false;

                this.preset.value = JSON.stringify(this.search);

                axios
                    .post('/api/presets', this.preset)
                    .then(response => {
                        this.isLoading = false;
                        this.showAlert(response.data.message);
                        this.getPresets();
                    }, error => {
                        this.isLoading = false;

                        if (error.response.status == 422) {
                            this.showAlert(error.response.data.errors.name[0], 'danger');
                        }
                    });
            },

            // Get Presets in Search Criteria 
            getPresets() {
                axios
                    .get('/api/presets/?entity=' + this.preset.entity)
                    .then(response => {
                        this.presetList = response.data;
                    }, error => {
                        console.log(error.response);
                    });
            },

            // Get Search results according to selected Preset Name
            loadPreset() {
                if (!this.preset) {
                    this.preset = {
                        entity: 'company'
                    };
                    this.clearSearch();
                    this.alert = false;
                    this.presetSelected = false;
                    return;
                }
                this.alert = false;
                this.presetSelected = true;
                this.search = JSON.parse(this.preset.value);
                this.searchCompany();
            },

            // Delete a selected Preset
            deletePreset() {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf === true) {
                    axios
                        .delete("/api/presets/" + this.preset.id)
                        .then(response => {
                            if (response.data.status == 'success') {
                                this.showAlert(response.data.message);
                                this.getPresets();
                                this.clearSearch();
                                this.preset.name = '';
                                this.preset.value = {};
                                this.presetSelected = false;
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                        });
                }
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>

<style scoped>

</style>
